import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../Config/api';
import { handleApiResponse } from "../sessionExpire/apiHelper";
import SessionExpire from '../sessionExpire/SessionExpire';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [sessionExpired, setSessionExpired] = useState(false);

  const accessToken = localStorage.getItem('token');
  // const apiKeymap = process.env.REACT_APP_API_KEY;
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [serviceData, setServiceData] = useState([]);

  const [loading, setLoading] = useState(true);
  const [cancellationData, setCancellationData] = useState([]);
  const [error, setError] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  // const fetchCancellationData = async (cancel_flag, month_flag,selectedYear,srv_flag,can_res_id,prof_alloc) => {

  //   if (!selectedYear) {
  //     console.error("Year is not selected or invalid:", selectedYear);
  //     return; // Don't make the API call if selectedYear is undefined or null
  //   }
  //   console.log({ cancel_flag, month_flag, selectedYear, srv_flag, can_res_id, prof_alloc });

  //   setError(null);
  //   try {
  //     const accessToken = localStorage.getItem('token');
  //     // console.log("all data",);

  //     const response = await axios.get(`${apiKeymap}/web/srv_enq_cancellation_data/`,{
  //       headers: {
  //         Authorization: `Bearer ${accessToken}` 
  //       },
  //       params: {
  //         cancel_flag,
  //         month_flag,
  //         year:selectedYear,
  //         srv_flag,
  //         can_res_id,
  //         prof_alloc
  //       }
  //     });
  //     setCancellationData(response.data);
  //     console.log("API Response:", response);

  //   } catch (err) {
  //     setError(err.message);
  //   }
  // };

  const fetchCancellationData = async (
    cancel_flag,
    month_flag,
    year,
    srv_flag,
    can_res_id,
    prof_alloc
  ) => {
    try {
      const accessToken = localStorage.getItem("token");

      const response = await axios.get(
        `${API_URL}/web/srv_enq_cancellation_data/`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          params: {
            cancel_flag,
            month_flag,
            year,
            srv_flag,
            can_res_id,
            prof_alloc,
          },
        }
      );

      setCancellationData(response.data);
      console.log("API Response:", response);
    } catch (err) {
      if (err?.response?.status === 403) {
        localStorage.clear();
        setSessionExpired(true);

        return;
      }

      setError(err.message);
      console.error("Error fetching cancellation data:", err);
    }
  };

  const handleAuth = () => {
    // setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', setIsLoggedIn(true));
  };
  const handleAuthLogout = () => {
    setIsLoggedIn(false);
  };


  const [submenuData, setSubmenuData] = useState([]);

  // Function to fetch cancellation reasons
  const fetchCancellationReasons = async (id) => {
    try {
      const response = await fetch(
        `${API_URL}/web/cancellation_reason_follow_up_list/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 403) {
        localStorage.clear();
        setSessionExpired(true);
        return;
      }

      if (response.ok) {
        const data = await response.json();
        setSubmenuData(data);
      } else {
        console.error(
          `Error: ${response.status} ${response.statusText}`
        );
      }
    } catch (error) {
      console.error(
        "Error fetching cancellation reasons:",
        error
      );
    }
  };
  // Function to fetch services data

  const fetchServicesData = async () => {
    console.log("Fetching services data...");

    try {
      const response = await axios.get(
        `${API_URL}/web/agg_hhc_services_api`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      setServiceData(response.data);
    } catch (error) {
      if (error?.response?.status === 403) {
        localStorage.clear();
        setSessionExpired(true);
        return;
      }

      setError(error.message);
      console.error("Error fetching services data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch services data on mount
  // useEffect(() => {
  //   fetchServicesData();
  // }, []);

  return (
    <>
      <SessionExpire open={sessionExpired} onClose={() => setSessionExpired(false)} />
      <AuthContext.Provider value={{ isLoggedIn, handleAuth, handleAuthLogout, cancellationData, fetchCancellationData, submenuData, fetchCancellationReasons, fetchServicesData, serviceData, selectedYear, setSelectedYear }}>
        {children}
      </AuthContext.Provider>
    </>
  );
};